export const GET_CUSTOMER_INFO_QUERY = `
query {
  customer {
    email
    firstname
    lastname
    middlename
  }
}
`;
